import React,  {Component} from 'react'; 
import MovieTimesTheatreContainer from '../cont/MovieTimesTheatreContainer';
import getDateObject from '../../../functions/getDateObj'
import MovieTimesPeriodeDays from '../cont/MovieTimesPeriodeDays';

const MovieTimes = ({ 
    movieData, 
    movieTimesDesktop, 
    periodesDays, 
    attributesColors, 
    activeWeek, 
    translation,
    hideTheatres, 
    chosen_font,
    colors, 
    iconsColor = 'dark', 
    itemStyle,
    hasFlyerCaptions, 
    captionAttributes, 
    reducedVersion, 
    cinemaData, 
    flyerDate=false
}) => {
    const { pk, performances, technologyAttributes } = movieData
    const today = getDateObject()
    const showTimesSortedAfterTheaterClass = reducedVersion || !movieTimesDesktop || movieTimesDesktop === 'standard' ? '' : '-theater-sorting'
    const captionsClass = hasFlyerCaptions ? ' has-captions' : ''
    const customWeek = _.keys(periodesDays).length > 7 ? ' custom-week' : ''
    
    if(!performances || Object.keys(performances) === 0) {
        return <div>Für diese Woche leider keine Spielzeiten geplant.</div>
    } else {
        return (
            <div className={"movie-times-wrapper"}>
                <div className={"movie-times" + showTimesSortedAfterTheaterClass + captionsClass + customWeek}>
                    {reducedVersion || !movieTimesDesktop || movieTimesDesktop === 'standard' ? (
                        <MovieTimesPeriodeDays
                            reducedVersion={reducedVersion}
                            cinemaData={cinemaData}
                            attributesColors={attributesColors}
                            colors={colors}
                            iconsColor={iconsColor}
                            chosen_font={chosen_font}
                            translation={translation}
                            hideTheatres={hideTheatres}
                            movieId={pk}
                            hasFlyerCaptions={hasFlyerCaptions}
                            captionAttributes={captionAttributes}
                            activeWeek={activeWeek}
                            itemStyle={itemStyle}
                            periodesDays={periodesDays}
                            performances={performances} 
                            today={today}
                            flyerDate={flyerDate}
                            />
                        ) : (
                        <div>MovieTimesTheatreContainer</div>
                        // <MovieTimesTheatreContainer
                        //     movieId={pk}
                        //     colors={colors}
                        //     cinemaData={cinemaData}
                        //     performances={performances}
                        //     activeWeek={activeWeek}
                        // translation={translation}
                        //     today={today} 
                        //     technologyAttributes={technologyAttributes}
                        // />
                    )}
                </div>
            </div>
        )
    }
}

export default MovieTimes